module.exports = __webpack_public_path__ + "img/7fb2278235a27a2c1b265de79e8e948d.jpg";